export default __webpack_public_path__ + "/dist/images/image00006.ac90ee61d107f41de7b2a90e5f971997.jpeg";